import { Stage } from 'konva/lib/Stage';
import { useEffect, useState } from 'react';
import { SandboxGame } from 'shared/lib/core';
import { HallmapContainer } from './styles';

export const HallmapGameLab = () => {
	const [mapInit, setMapInit] = useState(false);

	useEffect(() => {
		if (mapInit) {
			const stage = new Stage({
				container: 'sandbox-hallmap',
				width: 1000,
				height: 1000,
				draggable: true,
			});

			new SandboxGame(stage);
		}

		setMapInit(true);
	}, [mapInit]);

	return <HallmapContainer id="sandbox-hallmap" />;
};
